import React, { useState, useEffect, useRef } from 'react';

interface HeaderProps {
  children?: React.ReactNode;
}

const ResponsiveHeader: React.FC<HeaderProps> = ({ children }) => {
  const [isLandscape, setIsLandscape] = useState(false);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkOrientation = () => {
      const isLandscapeMode = window.matchMedia('(orientation: landscape)').matches;
      setIsLandscape(isLandscapeMode);
    };

    // Initial check
    checkOrientation();

    // Listen for orientation changes
    window.addEventListener('resize', checkOrientation);

    // Cleanup event listener
    return () => {
      window.removeEventListener('resize', checkOrientation);
    };
  }, []);

  // Conditionally render the header only when not in landscape mode
  return (
    <div ref={headerRef}>
      {!isLandscape && (
       <div className='topcenterheader'>HOME</div>
      )}
        {isLandscape && (
       <div className='slimtopspacer'>&nbsp;</div>
      )}
    </div>
  );
};

export default ResponsiveHeader;